export const formatAnomalyFilename = (
  exportExtension: string,
) => {
  const ext = exportExtension.startsWith('.') ? exportExtension : `.${exportExtension}`;
  const now = new Date();

  const pad = (n: number) => String(n).padStart(2, '0');

  const yyyy = now.getUTCFullYear();
  const mm = pad(now.getUTCMonth() + 1);
  const dd = pad(now.getUTCDate());
  const hh = pad(now.getUTCHours());
  const mi = pad(now.getUTCMinutes());
  const ss = pad(now.getUTCSeconds());

  const timestamp = `${yyyy}_${mm}_${dd}T${hh}_${mi}_${ss}Z`;

  return `BCF_${timestamp}${ext.toLowerCase()}`;
};

